import {stateData, reduxState} from '../../values';

export const getNotifications = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_notifications,
            payload:    data.Data,
            status:     stateData.state2,
            records:    data.Records
        })
    }
}

export const updateNotifications = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.update_notification,
            payload:    data,
        })
    }
}